'use client';

import { usePathname } from 'next/navigation';
import { useCallback } from 'react';

import { GTMBodyButtonClickParams, sendGTMEventBodyButtonClick } from '../lib/events';

export function useBodyButtonClick() {
  const pathname = usePathname();

  return useCallback(
    (params: GTMBodyButtonClickParams) => {
      sendGTMEventBodyButtonClick(pathname, params);
    },
    [pathname]
  );
}
